import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { VerifyEligibilityResponse} from "../../models/response/verify-eligibility-response/verify-eligibility-response";

@Injectable({
  providedIn: 'root'
})
export class VerifyEligibilityService {

  private verifyEligibilityUrl = `${environment.serverUrl}/verifyclient`;

  constructor(private http: HttpClient) {
  }

  verifyEligibility(): Observable<VerifyEligibilityResponse> {
    const httpOptions = {
      headers: new HttpHeaders(
        { 'Content-Type': 'application/json' }
      )
    }
    return this.http.get<VerifyEligibilityResponse>(this.verifyEligibilityUrl, httpOptions);
  }
}
